import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classes from './Test.module.css';
import usePageVisitTracker from '../../hooks/usePageVisitTracker';
import { FaArrowRight } from "react-icons/fa";


const LocationCards = ({ handleRatesClick }) => {
  const { trackPage } = usePageVisitTracker({ autoTrack: false });

  return (
    <section id='location-cards' className={`${classes.spiritDKLocation} ${classes.p40}`}>
      <Container>
        <Row>
          <Col md={6} className="track-mobile d-flex justify-content-center">
            <article 
              className={classes.spiritDkLocationItem + " mb-3 d-flex flex-column justify-content-center"} 
              style={{
                boxShadow:"0px 2px 8px 0px #00000014",
                width: "100%", 
                maxWidth: "430px",
                height:"200px",
              }}
            >
              <div className={classes.cardSecBHeader}>
                <h3 className={classes.cardSecBtitle}>Track Shipment</h3>
              </div>

                {/* New Track and Trace button */}
                <div style={{ borderTop: '1px solid #CCCCCC', margin: '0px 16px 16px', paddingTop: '20px' }}>
                  <a
                    href="https://sac-icargo.ibsplc.aero/icargoneoportal/app/main/#/app"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => { e.stopPropagation(); trackPage('/new-track-trace'); }}
                    className={classes.cardSecBButton}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      textDecoration: 'none',
                      fontWeight: '800',
                      lineHeight: '1',
                    }}
                  >
                  Track and Trace <FaArrowRight />
                  </a>
                </div>
            </article>
          </Col>

          <Col md={6} className="d-flex justify-content-center">
            <article 
              className={classes.spiritDkLocationItem + " mb-3 d-flex flex-column justify-content-center"} 
              style={{
                boxShadow:"0px 2px 8px 0px #00000014",
                width: "100%", 
                maxWidth: "430px",
                height:"230px"
              }}
            >
              <div className={classes.cardSecBHeader}>
                <h3 className={classes.cardSecBtitle}>Copenhagen</h3>
              </div>
              <div className={classes.cardSecBLink}>
                <span className={classes.spiritDKLocationItemIcon}>
                  <img src="./Rates.svg" className="rates-icon" alt="Search" />
                </span>
                <Link 
                  className={classes.spiritDKLocationItemLink}
                  // onClick={() => handleRatesClick('copenhagen')}
                  to='/ratescph'
                  style={{ background: 'none', border: 'none', cursor: 'pointer',color:"#000099" }}
                >
                  Rates
                </Link>
              </div>
              <Link to="/contact-us-cp" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'center', justifyContent: 'center' }}>
                <div className={classes.cardSecBAction}>
                  <button className={classes.cardSecBButton} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', lineHeight: '1' }}>
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      {/* <img src="./Contact.svg" className={classes.spiritDKContactIcon} alt="contact" /> */}
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', fontWeight: '800' }}>CONTACT US</span>
                  </button>
                </div>
              </Link>
            </article>
          </Col>

          <Col md={6} className="d-flex justify-content-center">
            <article 
              className={classes.spiritDkLocationItem + " mb-3 d-flex flex-column justify-content-center"} 
              style={{
                boxShadow:"0px 2px 8px 0px #00000014",
                width: "100%", 
                maxWidth: "430px",
                height:"230px"
              }}
            >
              <div className={classes.cardSecBHeader}>
                <h3 className={classes.cardSecBtitle}>Billund</h3>
              </div>
              <div className={classes.cardSecBLink}>
                <span className={classes.spiritDKLocationItemIcon}>
                  <img src="./Rates.svg" className="rates-icon" alt="Search" />
                </span>
                <Link 
                  className={classes.spiritDKLocationItemLink}
                  to='/ratesbll'
                  style={{ background: 'none', border: 'none', cursor: 'pointer',color:"#000099" }}
                >
                  Rates
                </Link>
              </div>
              <Link to="/contact-us-bl" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'center', justifyContent: 'center' }}>
                <div className={classes.cardSecBAction}>
                  <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', lineHeight: '1' }} className={classes.cardSecBButton}>
                    <span>
                      {/* <img src="./Contact.svg" className={classes.spiritDKContactIcon} alt="contact" /> */}
                    </span>
                    CONTACT US
                  </button>
                </div>
              </Link>
            </article>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LocationCards;

